import { memo, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_HOTEL } from 'constants/offer'
import OfferCardCarouselSection, { MIN_OFFER_CAROUSEL_OFFERS_COUNT } from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import Places from 'constants/places'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { LUXURY_PLUS } from 'luxPlus/constants/base'

function LuxPlusOfferCarousel() {
  const intl = useIntl()
  const canViewLuxPlusBenefits = useAppSelector(state => getCanViewLuxPlusBenefits(state))

  const filters: App.OfferListFilters = useMemo(() => ({
    offerTypes: [OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON],
    luxPlusFeatures: ['Member exclusive'],
    destinations: [Places.Anywhere.id],
    scheduleVisibilities: ['luxPlusExclusiveVisible'],
    limit: 20,
  }), [])

  const title = useMemo(
    () =>
      intl.formatMessage(
        {
          id: 'GRaDZxmUtxj2xBNcHnWZ',
          defaultMessage: 'Hidden offers, just for {programName} members',
          description: 'Title for LuxPlus exclusive offers carousel on the offer page',
        },
        { programName: LUXURY_PLUS.PROGRAM_NAME },
      ),
    [intl],
  )

  const subtitle = useMemo(
    () =>
      intl.formatMessage(
        {
          id: 'RK6VyiuBKqY9aq9V1bbo',
          defaultMessage: 'Unlock hidden hotel offers available exclusively for {programName} members. These escapes aren’t available anywhere else',
          description: 'Subtitle for LuxPlus exclusive offers carousel on the homepage',
        },
        { programName: LUXURY_PLUS.PROGRAM_NAME },
      ),
    [intl],
  )

  return (
    <OfferCardCarouselSection
      tileStyle={canViewLuxPlusBenefits ? 'card-default' : 'card-locked'}
      tileSize="medium"
      title={title}
      subtitle={subtitle}
      filters={filters}
      id="exclusive_offers"
      hideWhenEmpty
      minimumOffersCount={MIN_OFFER_CAROUSEL_OFFERS_COUNT}
      data-testid="luxplus-carousel"
    >
    </OfferCardCarouselSection>
  )
}

export default memo(LuxPlusOfferCarousel)
